import { Box, styled } from '@mui/material';

export const RootContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

export const MainContainer = styled(Box)(({ theme: { palette } }) => ({
  backgroundColor: palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
}));

export const ContentContainer = styled(Box)({
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});
